import { Box, useColorModeValue } from "@chakra-ui/react";

import { useGetThemeColors } from "ChakraTheme";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {}

const AppointmentTableBorder = ({ children }: IProps) => {
  const colors = useGetThemeColors();
  const borderColor = useColorModeValue(
    colors.primary[600],
    colors.primary[900]
  );

  return (
    <Box borderRadius={15} py={4} border={`solid 2px ${borderColor}`}>
      {children}
    </Box>
  );
};

export { AppointmentTableBorder };
